export default (theme) => ({
    root: {
        backgroundColor: theme.colors.actionMajor[500],
        borderRadius: 12,
        color: theme.colors.primary.white,
        cursor: 'pointer',
        display: 'flex',
        gap: 2,
        padding: '3px 6px 3px 8px',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: theme.colors.primary.white,
            color: theme.colors.actionMajor[500],
        },
    },
    menuContent: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 248,
    },
    menuItem: {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        gap: 8,
        padding: '8px 12px',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: theme.colors.actionMinor[50],
        },
    },
    open: {
        backgroundColor: theme.colors.primary.white,
        color: theme.colors.actionMajor[500],
    },
    popover: {
        '& .hoi-poi-popover-inner': {
            padding: 12,
        },
    },
});
